export default "__VITE_ASSET__DGi2hEsg__"